"use strict";

var _interopRequireDefault = require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/data/websites/erp-vue/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'rtc',
  components: {
    draggable: _vuedraggable.default
  },
  directives: {
    drag: function drag(el) {
      // 可就在里写指令的js代码
      var oDiv = el; // 当前元素
      // document.onselectstart = () => {
      //   return false
      // }
      oDiv.onmousedown = function (e) {
        // 鼠标按下时的鼠标所在的X，Y坐标
        // 鼠标按下，计算当前元素距离可视区的距离
        var disX = e.clientX - oDiv.offsetLeft;
        var disY = e.clientY - oDiv.offsetTop;
        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离 
          // 因为浏览器里并不能直接取到并且使用clientX、clientY,所以使用事件委托在内部做完赋值
          var l = e.clientX - disX;
          var t = e.clientY - disY;
          // 计算移动当前元素的位置，并且给该元素样式中的left和top值赋值
          oDiv.style.left = l + 'px';
          oDiv.style.top = t + 'px';
        };
        document.onmouseup = function (e) {
          // 鼠标抬起，清空之前所在的位置，新拖拽的位置已生成并赋值
          document.onmousemove = null;
          document.onmouseup = null;
        };
        // return false不加的话可能导致黏连，拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false;
      };
    }
  },
  data: function data() {
    return {
      queueSize: {
        queue: -1,
        seatCount: -1,
        activeUsers: -1,
        position: -1
      },
      phoneBarPosition: {
        x: 0,
        y: 0
      },
      // 初始化电话条位置
      draggableOptions: {
        // 可选的draggable选项
        // 在这里你可以配置限制拖动范围、拖动方向等
      },
      ioStatus: '',
      scriptDom: null,
      callMap: {
        1: '待机中...',
        2: '排队中...',
        3: '通话中...'
      },
      callStatus: 1,
      callLoading: false,
      callNumber: '',
      callNumberOpId: '',
      intervalController: 0
    };
  },
  mounted: function mounted() {
    this.initSocketListeners();
    this.$bus.$on('calling', this.handleSetNumber);
  },
  methods: {
    handleSetNumber: function () {
      var _handleSetNumber = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
        var mobile, opportunity_id;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              mobile = _ref.mobile, opportunity_id = _ref.opportunity_id;
              this.callNumber = mobile;
              this.callNumberOpId = opportunity_id;
              if (!this.callLoading) {
                _context.next = 6;
                break;
              }
              this.$message.info("当前已有在呼叫中的号码");
              return _context.abrupt("return");
            case 6:
              this.callLoading = true;
              this.$socket.emit('joinQueue');
              this.callStatus = 2;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleSetNumber(_x) {
        return _handleSetNumber.apply(this, arguments);
      }
      return handleSetNumber;
    }(),
    launchCallCenter: function () {
      var _launchCallCenter = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var that, _yield$this$$store$di, Token, SdkAppId, userId, SdkURL;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              _context2.next = 3;
              return this.$store.dispatch('loginCallCenter');
            case 3:
              _yield$this$$store$di = _context2.sent;
              Token = _yield$this$$store$di.Token;
              SdkAppId = _yield$this$$store$di.SdkAppId;
              userId = _yield$this$$store$di.userId;
              SdkURL = _yield$this$$store$di.SdkURL;
              console.log("%c Line:103 🌶 token, sdkAppId, userId, sdkUrl", "color:#6ec1c2", Token, SdkAppId, userId, SdkURL);
              if (!(!Token || !SdkAppId || !userId || !SdkURL)) {
                _context2.next = 12;
                break;
              }
              this.$message.error('您还未注册呼叫中心，请联系管理人员注册');
              return _context2.abrupt("return");
            case 12:
              this.scriptDom = document.createElement('script');
              this.scriptDom.setAttribute('crossorigin', 'anonymous');
              this.scriptDom.dataset.token = Token;
              this.scriptDom.dataset.sdkAppId = SdkAppId;
              this.scriptDom.dataset.userid = userId;
              this.scriptDom.src = SdkURL;
              this.scriptDom.classList.add('MuiBadge-root');
              document.body.appendChild(this.scriptDom);
              console.log("%c Line:109 🍧 scriptDom", "color:#ffdd4d", this.scriptDom);
              this.scriptDom.addEventListener('load', function () {
                var tcccSdkElement = document.querySelector('#tcccSdkDomRoot');
                var shadowRoot = tcccSdkElement.shadowRoot;
                var style = document.createElement('style');
                style.textContent = '.MuiBadge-root{pointer-events: none !important;}';
                shadowRoot.appendChild(style);
                // ready事件必须监听，否则容易发生tccc不存在的错误，所有呼入呼出的逻辑必须在ready事件触发后才可以调用
                window.tccc.on('ready', function () {
                  window.tccc.on('sessionEnded', function (data) {
                    console.info('sessionEnded', data);
                    that.leaveSeat();
                  });
                });
              });
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function launchCallCenter() {
        return _launchCallCenter.apply(this, arguments);
      }
      return launchCallCenter;
    }(),
    initSocketListeners: function initSocketListeners() {
      var that = this;
      // 获取到坐席
      that.$socket.on('seatAssigned', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              that.callStatus = 3;
              if (!that.scriptDom) {
                _context4.next = 12;
                break;
              }
              _context4.prev = 2;
              window.tccc.Agent.online();
              _context4.next = 10;
              break;
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](2);
              _context4.next = 10;
              return that.launchCallCenter();
            case 10:
              _context4.next = 14;
              break;
            case 12:
              _context4.next = 14;
              return that.launchCallCenter();
            case 14:
              that.intervalController = setInterval( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
                var localStatus;
                return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      localStatus = window.tccc.Agent.getStatus();
                      console.log("%c Line:175 🍕 localStatus", "color:#6ec1c2", localStatus);
                      if (!(localStatus == 'free')) {
                        _context3.next = 18;
                        break;
                      }
                      console.log('call', that.callNumber);
                      clearInterval(that.intervalController);
                      _context3.prev = 5;
                      _context3.next = 8;
                      return window.tccc.Call.startOutboundCall({
                        phoneNumber: that.callNumber,
                        uui: JSON.stringify({
                          opportunity_id: that.callNumberOpId
                        })
                      });
                    case 8:
                      _context3.next = 15;
                      break;
                    case 10:
                      _context3.prev = 10;
                      _context3.t0 = _context3["catch"](5);
                      console.error("\u547C\u51FA\u5931\u8D25\uFF1A", _context3.t0);
                      if (_context3.t0.errorMsg) {
                        that.$alert(_context3.t0.errorMsg);
                      } else {
                        that.$alert("此号码不可被呼叫！");
                      }
                      that.leaveSeat();
                    case 15:
                      _context3.prev = 15;
                      that.callLoading = false;
                      return _context3.finish(15);
                    case 18:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3, null, [[5, 10, 15, 18]]);
              })), 500);
              setTimeout(function () {
                var localStatus2 = window.tccc.Agent.getStatus();
                if (localStatus2 == 'offline') {
                  clearInterval(that.intervalController);
                  that.leaveSeat();
                }
              }, 10 * 1000);
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[2, 6]]);
      })));
      that.$socket.on('queueSize', function (data) {
        console.log("%c Line:1491 🍊 queueSize", "color:#f5ce50", data);
        that.queueSize = data;
      });
      setInterval(function () {
        that.$socket.emit('getSituation');
      }, 2000);
    },
    addSeat: function addSeat() {
      this.$socket.emit('addSeat');
    },
    joinQueue: function joinQueue() {
      this.$socket.emit('joinQueue');
      this.callStatus = 2;
    },
    leaveSeat: function leaveSeat() {
      window.tccc && window.tccc.Agent && window.tccc.Agent.offline();
      this.$socket.emit('leaveSeat');
      this.callStatus = 1;
      this.callLoading = false;
    },
    leaveQueue: function leaveQueue() {
      window.tccc && window.tccc.Agent && window.tccc.Agent.offline();
      this.$socket.emit('leaveQueue');
      this.callStatus = 1;
      this.callLoading = false;
    }
  }
};
exports.default = _default;